export default __webpack_public_path__ + "static/media/img_career_banner.cbccc855.png";